import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { httpActions, apiActions } from '..';
import { REQUEST, ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { IAppState } from '../../types/state.d';

export const fetchFrpData = (shortName: string) => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
) => {
  const resourceName = REQUEST.GET_FRP_DATA;

  try {
    dispatch(httpActions.httpRequestMade(resourceName));
    const response = await makeRequest(
      `${config.frpAPIv2}/byslug/${shortName}`,
      {
        credentials: 'same-origin',
      },
    );
    if (response && !response.ok) {
      throw new Error(ERROR_MESSAGES.GET_FRP_DATA);
    }
    const data = await response.json();
    dispatch(apiActions.saveFrpData(data));
    dispatch(httpActions.httpRequestSuccess(resourceName));
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
  }
};

export default fetchFrpData;
